import { Component } from '@angular/core';

@Component({
  selector: 'uni-page',
  templateUrl: './uni-page.component.html',
  styleUrls: ['./uni-page.component.scss'],
})
export class UniPageComponent { }
